/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionRule } from '../../models/distribution-rule';
import { DistributionRuleUpdateRequest } from '../../models/distribution-rule-update-request';

export interface UpdateRule$Params {
  'Active-Tenant-Identifier': string;
  ruleId: string;
      body: DistributionRuleUpdateRequest
}

export function updateRule(http: HttpClient, rootUrl: string, params: UpdateRule$Params, context?: HttpContext): Observable<StrictHttpResponse<DistributionRule>> {
  const rb = new RequestBuilder(rootUrl, updateRule.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('ruleId', params.ruleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DistributionRule>;
    })
  );
}

updateRule.PATH = '/distribution-rules/{ruleId}';
